// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"wh_a bhs_b"};